module.exports = vendor_52f9263124db20bb8e77;


//////////////////
// WEBPACK FOOTER
// external "vendor_52f9263124db20bb8e77"
// module id = iWPu
// module chunks = 15 16 17 18 19 20